import React from 'react';
import { observer } from 'mobx-react';
import { CustomTabStore, SiteStore, RouteStore } from '@seedlang/stores';
import { observable } from 'mobx';
import { AppUI } from '@seedlang/state';
import ButtonPrimary from 'components/button/button_primary';

@observer
class CustomTabCreate extends React.Component {
  @observable siteId = '';

  componentDidMount() {
    SiteStore.getIndex();
  }

  onClick() {
    CustomTabStore.create(
      {
        data: {
          title: this.refs.title.value,
          site_id: AppUI.site.id,
        },
      }, this.afterCreate.bind(this));
    this.refs.title.value = '';
  }

  onSelect(e) {
    this.siteId = e.target.value;
  }

  afterCreate(resp) {
    if (resp.customTabId && AppUI.groupId) {
      RouteStore.routeToNamed('creator.custom_tabs.edit', {customTabId: resp.customTabId, groupId: AppUI.groupId});
    } else {
      this.error = true;
    }
  }

  render() {
    return (
      <div className='custom tab-create'>
        {
          this.error &&
            <div className='alert'>Sorry, there was an error</div>
        }
        <input
          placeholder='Add a custom tab title'
          ref='title'
        />
        <div>
          <ButtonPrimary
            style={{marginTop: '10px'}}
            onClick={this.onClick.bind(this)}
          >
            Create
          </ButtonPrimary>
        </div>
      </div>
    );
  }
}

export default CustomTabCreate;
